import GallerySection from './gallery-section';

export default GallerySection;
